import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SECTIONS } from "@/lib/sections";

export default function PlannedPage({ sectionKey }) {
  const section = SECTIONS[sectionKey];
  const Icon = section.icon;
  return (
    <div className="h-full overflow-y-auto" data-testid={`planned-page-${sectionKey}`}>
      <div className="mx-auto flex min-h-full w-full max-w-[640px] flex-col justify-center px-6 py-16 cs-rise">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-ink-850">
          <Icon className="h-[22px] w-[22px] text-zinc-200" strokeWidth={1.5} />
        </div>
        <div className="mt-7 text-[11px] font-medium uppercase tracking-[0.18em] text-zinc-500" data-testid="planned-page-badge">
          Planned
        </div>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight text-white sm:text-4xl">{section.label}</h1>
        <p className="mt-3 text-[15px] leading-relaxed text-zinc-400" data-testid="planned-page-description">{section.description}</p>
        <p className="mt-6 text-sm text-zinc-500">
          {section.label} isn't available yet and will arrive in a later phase. Chat works today.
        </p>
        <Link to="/" className="mt-8 inline-flex w-fit items-center gap-2 rounded-full border border-white/12 px-4 py-2 text-sm text-zinc-200 transition-colors hover:bg-white/[0.05]" data-testid="planned-page-home-link">
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </Link>
      </div>
    </div>
  );
}
